"use client";

import { useCalculator } from "./CalculatorContext";

function CalcIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="5" y="3" width="14" height="18" rx="1.5" />
      <line x1="5" y1="9" x2="19" y2="9" />
      {/* button dots — zero-length lines with round caps render as small dots */}
      <line x1="9" y1="13" x2="9" y2="13" strokeWidth={2.5} />
      <line x1="12" y1="13" x2="12" y2="13" strokeWidth={2.5} />
      <line x1="15" y1="13" x2="15" y2="13" strokeWidth={2.5} />
      <line x1="9" y1="17" x2="9" y2="17" strokeWidth={2.5} />
      <line x1="12" y1="17" x2="12" y2="17" strokeWidth={2.5} />
      <line x1="15" y1="17" x2="15" y2="17" strokeWidth={2.5} />
    </svg>
  );
}

export default function CalculatorButton() {
  const { open, toggleCalc } = useCalculator();
  return (
    <button
      type="button"
      onClick={toggleCalc}
      aria-label="Miniräknare"
      title={open ? "Stäng miniräknaren" : "Öppna miniräknare"}
      className={`p-2 rounded-md transition-colors ${
        open
          ? "text-[var(--color-accent)]"
          : "text-[var(--color-nav-text)] hover:bg-[var(--color-nav-border)]"
      }`}
    >
      <CalcIcon className="w-5 h-5" />
    </button>
  );
}
